import * as v from 'valibot';
import { FileSchema } from '.';

export const ExportReportSchema = v.variant('exportStrategy', [
	v.object({
		exportStrategy: v.literal('immediate'),
		result: FileSchema,
	}),
	v.object({
		exportStrategy: v.literal('background'),
		status: v.picklist([ 'queued', 'missingEmail' ]),
	}),
]);
